import { useEffect } from "react";
import { withRouter } from "react-router-dom";

const CATALOG_PATHS = ["/todos", "/convencional", "/plan", "/preventa", "/"];

function ScrollToTop({ history }) {
  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (CATALOG_PATHS.includes(location.pathname)) return;
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return null;
}

export default withRouter(ScrollToTop);
